import React, { ReactNode, useState } from 'react'
import { Chevron } from '../../../../assets/icons'
import { colors } from 'app-v2/design-systems/theme/colors'
import styled from 'styled-components'
import { fonts } from 'app-v2/design-systems/typography/fonts'
import { TPKColors } from '../../../colors'

type FAQItemProps = {
    question: string,
    children: ReactNode
}

export const FAQItem = ({ question, children }: FAQItemProps) => {
    const [open, setOpen] = useState(false)
    return (
        <StyledFaqItem opened={open}>
            <StyledQuestion
                href={'#'}
                onClick={e => {
                    e.preventDefault()
                    setOpen(open => !open)
                }}>
                {question}{' '}
                <Chevron
                    color={colors.bbqBrown}
                    direction={open ? 'up' : 'down'}
                />
            </StyledQuestion>

            <StyledAnswer opened={open}>
                <StyledAnswerText>{children}</StyledAnswerText>
            </StyledAnswer>
        </StyledFaqItem>
    )
}

const StyledFaqItem = styled.div`
    border-radius: 4px;
    display: flex;
    border-top: 1px solid ${colors.bbq30};
    ${props =>
        props.opened
            ? `border-top: 1px solid ${colors.flamingOrange};`
            : `border-top: 1px solid ${colors.bbq30};`}
    background: ${TPKColors.faqBorder};
    flex-direction: column;
`

const StyledQuestion = styled.a`
    display: flex;
    font-size: 18px;
    line-height: 1.5;
    font-family: ${fonts.flameRegular};
    color: ${colors.bbqBrown};
    justify-content: space-between;
    align-items: center;
    &:active,
    &:hover {
        color: ${colors.bbqBrown};
    }
    padding: 24px;
`

const StyledAnswer = styled.div`
    overflow: hidden;
    max-height: 0;
    padding: 0 24px;
    transition: max-height 0.2s, padding 0.2s;
    ${props =>
        props.opened &&
        `
        max-height: none; 
        padding: 24px;`}
`

const StyledAnswerText = styled.div`
    color: ${colors.bbqBrown};
    font-family: ${fonts.flameSansRegular};
    font-size: 16px;
    line-height: 1.6;

    p {
        margin: 0 0 18px 0;
    }

    h4 {
        font-family: ${fonts.flameRegular};
        padding: 0;
    }

    a {
        text-decoration: underline;
    }

    b {
        font-weight: normal;
        font-family: ${fonts.flameRegular};
    }

    ul {
        li {
            list-style: disc;
            margin-bottom: 8px;
        }
        margin-left: 12px;
        padding-left: 8px;
        margin-bottom: 24px;
    }
`
